import { Route } from '@angular/router';
import { LoggedInGuard, PendingChangesGuard } from '@spotter/guards/login-guard';

/** Adds the routes for absence pages. */
export function addAbsencePageRoutes(): Route[] {
  return [
    {
      path: 'absences/upload', canActivate: [LoggedInGuard], canDeactivate: [PendingChangesGuard],
      loadComponent: () => import('../pages/absences/new-absence-page/new-absence-page.component').then(m => m.NewAbsencePageComponent)
    },
    {
      path: 'absences/grid',
      loadComponent: () => import('../pages/absences/absence-grid-page/absence-grid-page.component').then(m => m.AbsenceGridPageComponent)
    },
    {
      path: 'absences/map',
      loadComponent: () => import('../pages/absences/map-absence-page/map-absence-page.component').then(m => m.MapAbsencePageComponent)
    },
    {
      path: 'absence/:id',
      loadComponent: () => import('../pages/absences/absence-single-page/absence-single-page.component').then(m => m.AbsenceSinglePageComponent)
    },
    {
      path: 'absence/:id/edit', canActivate: [LoggedInGuard],
      loadComponent: () => import('../pages/absences/edit-absence-page/edit-absence-page.component').then(m => m.EditAbsencePageComponent)
    },
  ];
}